import React, { useState } from 'react';
import { products } from '../mock';
import { ArrowUpRight, Droplets } from 'lucide-react';
import { Button } from './ui/button';

export default function Products() {
  const [active, setActive] = useState(0);

  return (
    <section id="products" className="relative py-24 bg-gradient-to-b from-white via-sky-50/50 to-white overflow-hidden">
      <div className="bubble w-32 h-32 top-16 right-10 opacity-40" />
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <div className="text-xs tracking-[0.3em] text-sky-600 font-semibold uppercase mb-3">Product Range</div>
            <h2 className="font-display text-4xl md:text-5xl font-semibold text-slate-900 leading-tight max-w-2xl">
              Three devices. Every kind of <span className="water-text">luxury use case</span>.
            </h2>
          </div>
          <div className="flex gap-2">
            {products.map((p, i) => (
              <button key={p.id} onClick={() => setActive(i)} className={`px-4 py-2 rounded-full text-sm font-medium border transition-all ${i === active ? 'bg-slate-900 text-white border-slate-900' : 'bg-white text-slate-700 border-slate-200 hover:border-sky-300'}`}>
                {p.name}
              </button>
            ))}
          </div>
        </div>

        <div className="grid lg:grid-cols-3 gap-6">
          {products.map((p, i) => (
            <article key={p.id} className={`product-card group relative rounded-[2rem] overflow-hidden bg-white border border-sky-100 shadow-md ${i === active ? 'ring-2 ring-sky-400' : ''}`}>
              <div className="relative h-64 overflow-hidden">
                <div className={`absolute inset-0 bg-gradient-to-br ${p.color} opacity-90`} />
                <img src={p.image} alt={p.name} className="absolute inset-0 w-full h-full object-cover mix-blend-overlay opacity-80 group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute top-4 left-4 px-3 py-1 rounded-full bg-white/90 backdrop-blur text-xs font-semibold text-slate-800">{p.tag}</div>
                <div className="absolute bottom-4 right-4 flex items-center gap-1.5 text-white">
                  <Droplets className="w-4 h-4" />
                  <span className="text-sm font-semibold">{p.capacity}</span>
                </div>
              </div>
              <div className="p-6">
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <h3 className="font-display text-2xl font-semibold text-slate-900">{p.name}</h3>
                    <p className="text-sm text-sky-700 font-medium mt-1">{p.tagline}</p>
                  </div>
                  <div className="w-10 h-10 rounded-full bg-sky-50 flex items-center justify-center group-hover:bg-sky-500 group-hover:text-white transition-colors">
                    <ArrowUpRight className="w-4 h-4" />
                  </div>
                </div>
                <p className="mt-4 text-sm text-slate-600 leading-relaxed">{p.description}</p>
                <div className="mt-6 flex items-center justify-between border-t border-slate-100 pt-4">
                  <Button variant="ghost" className="text-sky-700 hover:text-sky-800 hover:bg-sky-50 -ml-3">Read More →</Button>
                  <span className="text-xs text-slate-500">0{i + 1}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
